// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

export const getIsCommerceWebsite = (state: ApplicationState) => {
    return getSettingsCollection(state).grabberSettings.enableCommerce;
};
